@if (isEsko || (parentBranding$ | async)) {
  <mat-icon [ngClass]="class">esko_logo</mat-icon>
} @else {
  <mat-icon [ngClass]="class">zef_logo</mat-icon>
}
